export default class SidebarService {
	constructor($injector) {
		this.$rootScope = $injector.get('$rootScope');
		this.sidebar = {
			show: true
		};
	}

	toggleSidebar() {
		this.sidebar.show = !this.sidebar.show;
		this.$rootScope.$broadcast('content:toggle');
		return this.sidebar.show;
	}

	isOpen() {
		return this.sidebar.show;
	}
}
